import { Tab, Tabs } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { primaryColor } from '@themes/defaultThemeProps';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  tabItemStyle: {
    textTransform: 'capitalize',
    fontSize: '16px',
  },
  tabGlobalStyle: {
    borderBottom: '1px solid #ccc',
  },
});

const RegularTab = ({
  tabs,
  selectedTab,
  onTabChange,
  color,
  fullWidth,
  className,
  muiClasses,
  ...rest
}) => {
  const classes = useStyles();
  const tabClasses = classNames({
    [classes[color]]: color,
    [classes.fullWidth]: fullWidth,
    [className]: className,
    [classes.tabItemStyle]: true,
    [classes.tabGlobalStyle]: true,
  });

  return (
    <Tabs
      TabIndicatorProps={{
        style: {
          backgroundColor: primaryColor[0],
          height: '5px',
        },
      }}
      value={selectedTab}
      variant='fullWidth'
      onChange={onTabChange}
      classes={{ indicator: classes[color] }}
      {...rest}
    >
      {tabs.map((tab, index) => (
        <Tab
          style={{
            color: selectedTab === index ? primaryColor[0] : '#0009',
            padding: '0px',
            fontSize: 'clamp(13.5px, 1vw, 16px)',
        }}
          key={index}
          label={`${tab.name}`}
          className={tabClasses}
          classes={muiClasses}
        />
      ))}
    </Tabs>
  );
};

RegularTab.propTypes = {
  tabs: PropTypes.arrayOf({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    completed: PropTypes.bool.isRequired,
  }).isRequired,
  selectedTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  color: PropTypes.oneOf(['primary']),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
};

export default RegularTab;
